const VIEWS = {
  SHARE_VIEW: 'share',
  QUOTES_VIEW: 'quotes', // for old links
  DOCUMENTS_VIEW: 'documents',
};

module.exports = VIEWS;
